import { H3, Link, Paragraph } from '@increasecard/typed-components';
import styled from 'styled-components';
import { Container } from '../components/Containers';
import SectionTitle from '../components/SectionTitle';

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export function Support() {
  return (
    <Container>
      <SectionTitle>Nuestros canales de contacto</SectionTitle>
      <Stack>
        <H3>Para consultas sobre Pay</H3>
        <Paragraph>
          <span aria-label="emoji carta" role="img">
            📩
          </span>{' '}
          <Link href="mailto:soporte.pay@clickdepago.com.ar" target="_blank">
            soporte.pay@clickdepago.com.ar
          </Link>
        </Paragraph>
      </Stack>
      <Stack>
        <H3>Para consultas sobre Card</H3>
        <Paragraph>
          <span aria-label="emoji carta" role="img">
            📩
          </span>{' '}
          <Link href="mailto:soporte.card@clickpago.com.ar" target="_blank">
            soporte.card@clickpago.com.ar
          </Link>
        </Paragraph>
      </Stack>
    </Container>
  );
}
